import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X4UnitStore} from '../X4UnitStore';

@observer
export class DeleteLessonControls extends React.Component<{ store: X4UnitStore }> {
  render() {
    const {store} = this.props;

    if (store.deleteLesson === null)
      return null;

    const deleteLesson = store.deleteLesson;
    const isFailure = deleteLesson.save?.isRejected === true;

    return (<>
      <PromiseMessage label="Deleting" state={deleteLesson.save} align="right"/>

      {
        isFailure &&
        <div className="row justify-content-end" key="delete-actions">
          <div className="col-auto">
            <button type="button" className="btn btn-primary"
                    onClick={() => store.beginDelete(deleteLesson.lessonId)}> Retry
            </button>
            <button type="button" className="btn btn-primary"
                    onClick={store.cancel}> Cancel
            </button>
          </div>
        </div>
      }
    </>);
  }
}
